import React, { useState } from 'react';

interface AccordionProps {
    data: {
        title: string;
        content: string;
    };
}

const Accordion: React.FC<AccordionProps> = ({ data }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex flex-col w-full py-5 px-6 border-y border-orange-secondary mt-[-1px] gap-3 text-left" >
            <button
                    type="button"
                    className="flex justify-between items-center !text-xl !laptop:text-2xl font-semibold group focus-visible:rounded-lg focus-visible:border-0 focus-visible:outline outline-offset-4 focus-visible:outline-red-secondary focus-visible:outline-4"
                    onClick={() => setIsOpen(!isOpen)}
            >
                <span className="group-hover:underline">{data.title}</span>
                <div
                    className={`${isOpen ? 'icon-minus' : 'icon-plus'}`}
                    aria-hidden="true"
                >
                </div>
            </button>
            {isOpen && (
                <div
                    className="accordionText"
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />
            )}
        </div>
    );
};

export default Accordion;